import request from "@/utils/request";
import Vue from "vue";
// const server = "/cloudhealth-server-portal"
const server = "";

/**
 * 方案获取
 * @query {} query
 */
export function getCancerManagePlanByIdcard(query) {
  return request({
    url: server + `/business/cancer/plan/getCancerManagePlan`,
    method: "post",
    params: query,
  });
}

/**
 * 方案保存
 * @query {} query
 */
export function postSaveCancerManagePlan(query) {
  return request({
    url: server + "/business/cancer/plan/saveCancerManagePlan",
    method: "post",
    data: query,
  });
}

/**
 * 一件随访提交
 * @query {} query
 */
export function postFollowupNotification(query) {
  return request({
    url: server + "/business/patientFollowupRecord/notification",
    method: "post",
    data: query,
  });
}

/**
 * 一件协诊提交
 * @query {} query
 */
export function postCoDiagnosisNotification(query) {
  return request({
    url: server + "/business/patientCoDiagnosis/coDiag",
    method: "post",
    data: query,
  });
}

/**
 * 获取病理和手术的接口
 * @query {idcard} query
 */
export function postListLungDetail(query) {
  return request({
    url: server + "/business/doctor/listLungDetail",
    method: "post",
    data: query,
  });
}

/**
 * 获取癌症疾病分组接口（管理标签数据）
 * @query {groupName} query
 */
export function postPatientFollowupGroupsByGroupName(query) {
  return request({
    url: server + "/business/patientFollowupGroups/list",
    method: "post",
    data: query,
  });
}

/**
 * 增加癌症疾病分组接口
 * @query {groupName} query
 */
export function postAddPatientFollowupGroup(query) {
  return request({
    url: server + "/business/patientFollowupGroups/add",
    method: "post",
    data: query,
  });
}

/**
 * 删除癌症疾病分组接口
 * @query {groupName} query
 */
export function postDeletePatientFollowupGroup(query) {
  return request({
    url: server + "/business/patientFollowupGroups/deleteByGroupNamne",
    method: "post",
    data: query,
  });
}

/** 获取省市区乡镇列表 */
export function postAreaList(query) {
  return request({
    url: server + "/business/areaCode/list?page=1&pageSize=100",
    method: "post",
    data: query,
  });
}

/**
 * 提交肺结节随访单（同时更新管理方案）
 */
export function submitLungcancerFollowup(query) {
  return request({
    url: server + "/business/cancer/lungcancerFollowup/submit",
    method: "post",
    data: query,
  });
}

/**
 * 查询最新的肺结节随访单
 */
export function getLatestLungcancerFollowup(params) {
  return request({
    url: server + "/business/cancer/lungcancerFollowup/getLatest",
    method: "post",
    params: params,
  });
}

export function getLungcancerFollowupByRecordId(params) {
  return request({
    url: server + "/business/cancer/lungcancerFollowup/getByFollowupRecordId",
    method: "get",
    params,
  });
}

/**
 * 终止管理
 * @param {idcard, reason} data
 */
export function postTerminateManagement(data) {
  return request({
    url: server + "/business/cancer/plan/terminateManagement",
    method: "post",
    data: data,
  });
}
